// Each offer either opens an in-app page (`link`), opens a WhatsApp chat with
// a prefilled message about the offer (`chat`), or is display-only (neither).
const FlashOffersData = [
  {
    id: 1,
    name: "Quick Start Website Plan for Small Business and Startups @ $99",
    link: "/theme-store",
  },
  {
    id: 2,
    name: "Annual Graphic Design Package @ $149",
    chat: true,
  },
  {
    id: 3,
    name: "All in One SEO @ $299",
    chat: true,
  },
  {
    id: 4,
    name: "Logo Design @ $9",
    chat: true,
  },
  {
    id: 5,
    name: "Full IT Service Package Coming Soon...",
  },
];

export default FlashOffersData;
